import { QueryOperatorEntity } from '~/types/OpenSearch';

export const AND: QueryOperatorEntity = { type: 'operator', value: 'and' };
